export const colors = {
  primary: "#0f766e",
  primaryDark: "#115e59",
  primaryLight: "#ccfbf1",

  background: "#f8fafc",
  surface: "#ffffff",
  surfaceMuted: "#f1f5f9",

  border: "#e5e7eb",
  borderStrong: "#cbd5e1",

  text: "#0f172a",
  textMuted: "#64748b",
  textSoft: "#94a3b8",

  success: "#16a34a",
  successBg: "#dcfce7",

  warning: "#d97706",
  warningBg: "#fef3c7",

  danger: "#dc2626",
  dangerBg: "#fee2e2",

  info: "#2563eb",
  infoBg: "#dbeafe"
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  "2xl": 32,
  "3xl": 40
};

export const radii = {
  sm: 6,
  md: 8,
  lg: 12,
  xl: 16,
  full: 999
};

export const shadows = {
  sm: "0 1px 2px rgba(15, 23, 42, 0.06)",
  md: "0 8px 24px rgba(15, 23, 42, 0.08)",
  lg: "0 16px 40px rgba(15, 23, 42, 0.12)"
};

export const typography = {
  fontFamily:
    "Inter, Manrope, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",

  h1: {
    fontSize: "32px",
    lineHeight: "40px",
    fontWeight: 800
  },

  h2: {
    fontSize: "24px",
    lineHeight: "32px",
    fontWeight: 750
  },

  h3: {
    fontSize: "18px",
    lineHeight: "26px",
    fontWeight: 700
  },

  body: {
    fontSize: "15px",
    lineHeight: "24px",
    fontWeight: 400
  },

  small: {
    fontSize: "13px",
    lineHeight: "20px",
    fontWeight: 400
  }
};

export const layout = {
  sidebarWidth: 260,
  topbarHeight: 64,
  pageMaxWidth: 1400
};